module.exports = __webpack_public_path__ + "img/managed-docs.9dd640c6.svg";